const Skeleton = ({ className = "" }) => (
  <div className={`animate-pulse rounded-xl bg-gray-100 ${className}`} aria-hidden="true" />
);

export default function MenuOverviewSkeleton() {
  return (
    <div className="mx-auto w-full max-w-6xl p-4 sm:p-5 lg:p-6" aria-label="در حال بارگذاری اطلاعات منو">
      <Skeleton className="h-6 w-32" />
      <Skeleton className="mt-2 h-3.5 w-64 max-w-full" />
      <div className="mt-4 space-y-4">
        <div className="flex gap-3 border-b border-gray-100 pb-2.5">
          {[0, 1, 2].map((item) => <Skeleton key={item} className="h-6 w-28 shrink-0" />)}
        </div>
        <div className="grid gap-4 lg:grid-cols-[minmax(0,1fr)_18rem]">
          <div className="space-y-4">
            <Skeleton className="h-56 w-full" />
            <Skeleton className="h-40 w-full" />
          </div>
          <Skeleton className="h-80 w-full" />
        </div>
      </div>
    </div>
  );
}
